<template>
  <div :style="styles.container">
    <div
      :style="{
        ...styles.drawer,
        height: drawerHeight + '%',
        transition: isDragging ? 'none' : 'height 0.3s ease',
      }"
      @touchstart="handleTouchStart"
      @touchmove="handleTouchMove"
      @touchend="handleTouchEnd"
    >
      <div :style="styles.handle" />
      <div
        class="px-4 mt-4"
        :style="styles.drawerContent"
      >
        <i
          class="fa-solid fa-xmark fs-2"
          style="position:absolute; right: 20px;top:20px; color: #ccc;"
          @click="drawerHeight=0"
        />
        <login-component
          v-if="login_mode"
          :is_drawer="true"
          @go-register="login_mode=false"
        />
        <div v-else-if="!registered">
          <div v-if="!info">
            <h1
              class="mb-3 mt-2 text-center"
              style="color:#394A64; font-weight: 600;"
            >
              Confirma tus datos
            </h1>
            <p
              v-if="!user_not_register"
              class="ps-3"
              style="color:#56647A"
            >
              Introduce tu email para continuar
            </p>
            <div class="form-floating mt-3 mb-2">
              <input
                v-model="userRegister.email"
                type="email"
                class="form-control"
                placeholder="email"
              >
              <label>Mail <span class="text-danger">*</span></label>
            </div>
            <span
              v-if="tried_register && !email_regex.test(userRegister.email)"
              class="ms-3 text-danger"
            >Email incorrecto</span>
            <div v-if="user_not_register">
              <div v-if="is_driver">
                <p
                  class="text-center mb-0 fw-bold py-3"
                  style="color:black"
                  @click="info=true"
                >
                  <img 
                    style="height: 30px; width: 30px;"
                    class="me-2"
                    src="../assets/info_icon.png"/>¿Por qué solicitamos estos datos?
                </p>
              </div>
              <div v-else>
                <p
                  class="text-center mb-0"
                  style="color:#56647A"
                >
                  Parece que aún no te habias registrado en Parkiduo. Solo necesitamos algunos datos para continuar.
                </p>
              </div>
              <div class="form-floating mt-2 mb-2">
                <input
                  v-model="userRegister.name"
                  type="text"
                  class="form-control"
                  placeholder="Nombre"
                >
                <label>Nombre <span class="text-danger">*</span></label>
              </div>
              <span
                v-if="tried_register && userRegister.name.length==0"
                class="ms-3 text-danger"
              >Rellene su nombre</span>
              <div class="form-floating mt-2 mb-1">
                <input
                  v-model="userRegister.mobile_phone"
                  type="phone"
                  class="form-control"
                  placeholder="Teléfono"
                >
                <label>Teléfono <span class="text-danger">*</span></label>
              </div>
              <span
                v-if="tried_register && !phone_regex.test(userRegister.mobile_phone)"
                class="ms-3 text-danger"
              >Número de telefono no valido</span>
              <div class="form-check mt-2 mb-1">
                <input
                  id="flexCheckDefault"
                  v-model="terms_conditions"
                  class="form-check-input"
                  type="checkbox"
                >
                <label
                  style="color: #56647A;"
                  class="form-check-label"
                  for="flexCheckDefault"
                >
                  He leído y acepto los 
                  <a
                    style="color:#15E0DD;text-decoration: none; cursor: pointer;"
                    href="https://parkiduo.com/terminos-y-condiciones/"
                    target="_blank"
                  >Términos y Condiciones </a>
                  y
                  <a
                    style="color:#15E0DD;text-decoration: none; cursor: pointer;"
                    href="https://parkiduo.com/politica-privacidad/"
                    target="_blank"
                  > Política de Privacidad</a>
                </label>
              </div>
              <span
                v-if="tried_register && !terms_conditions"
                class="ms-3 text-danger"
              >Acepta los Términos y Condiciones</span>
            </div>
            <div
              class="mt-4"
              style="height: 120px;"
            >
              <p
                v-if="error"
                class="text-danger text-center mb-2"
              >
                Ha habido un error en el registro
                <i class="fa-regular fa-face-sad-tear ms-2" />
              </p>
              <button
                class="btn py-2 w-100 rounded-3"
                style="background-color: #15E0DD; font-size: 1.1rem;font-weight: 600; color: #007B79"
                @click="register_user"
              >
                <span>Confirmar</span>
              </button>
              <!--<p class="text-center mt-2">
                Already have an account?
                <span
                  @click="login_mode=true;"
                  style="cursor: pointer;color: #15E0DD;text-decoration: none;font-weight: 500"
                >
                  Log in
                </span>
              </p>-->
            </div>
          </div>
          <div 
            v-else 
            class="px-3">
            <img 
              style="height: 40px; width: 40px;"
              src="../assets/info_icon.png"/>
            <p class="mt-3">
              Solicitamos tu teléfono por 2 motivos:
            </p>
            <ol style="padding-left: 1rem;">
              <li>Para enviarte los garajes disponibles por Whatsapp.</li>
              <li>Para que el anunciante del garaje que quieras visitar pueda ponerse en contacto contigo.</li>
            </ol>
            <p class="py-2 fw-bold">
              No lo utilizaremos para enviarte publicidad ni nada por el estilo ;)
            </p>
            <div class="w-100 d-flex align-items-center justify-content-center">
              <button
                class="btn rounded-4 fw-semibold w-75 py-2  text-center"
                style="background-color: #15E0DD; color:#011638"
                @click="info=false" >
                ¡Entendido!
              </button>
            </div>
          </div>
        </div>
        
      </div>
    </div>
    <spinner-component
      id="spinner"
      style="z-index: 10000;"
      class="d-none"
    />
  </div>
</template>

  <script>
  import axios from 'axios';
  import LoginComponent from './LoginComponent.vue';
  import SpinnerComponent from './SpinnerComponent.vue';
  import mixpanel from 'mixpanel-browser';

  export default {
    name: 'DrawerComponentLogin',
    components: {
      LoginComponent,
      SpinnerComponent
    },
    data() {
      return {
        drawerHeight: 0, // Altura inicial
        isDragging: false, // Si el usuario está arrastrando
        login_mode: false,
        userRegister: {
          name: "",
          mobile_phone: "",
          email: "",
        },
        user_not_register: false,
        error: false,
        tried_register: false,
        registered: false,
        info: false,
        phone_regex: /^[6789](?:\d\s?){8}$/,
        email_regex: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
        terms_conditions: false,
        autoLogin: false
      };
    },
    props: {
        is_driver:{
          type: Boolean,
          required: false,
          default: false
        },
      },
    computed: {
      styles() {
        return {
          container: {
            zIndex: '1000 !important',
            position: 'relative',
            maxheight: '100vh',
            backgroundColor: '#f5f5f5',
            overflow: 'hidden',
          },
          drawer: {
            position: 'fixed',
            bottom: 0,
            left: 0,
            width: '100%',
            backgroundColor: '#fff',
            boxShadow: '0 -4px 8px rgba(0, 0, 0, 0.2)',
            borderTopLeftRadius: '20px',
            borderTopRightRadius: '20px',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            maxheight: '100% !important',
            zIndex: '2000',
            overflowY: 'scroll',
          },
          handle: {
            width: '50px',
            height: '6px',
            backgroundColor: '#ccc',
            borderRadius: '3px',
            margin: '10px 0',
          },
          drawerContent: {
            padding: '0px',
            width: "100%",
          },
        };
      },
    },
    methods: {
      closeDrawer(){
          this.drawerHeight = 0
      },
      openDrawer(){
          this.drawerHeight = 90
      },
      handleTouchStart() {
        this.isDragging = true;
      },
      handleTouchMove(event) {
        if (this.isDragging) {
          const touchY = event.touches[0].clientY;
          const screenHeight = window.innerHeight-60;
          let newHeight = screenHeight - touchY;

          if (newHeight >= 100 && newHeight <= screenHeight) {
            newHeight = (newHeight / window.innerHeight) * 100
            this.drawerHeight = newHeight+10;
          }

        }
      },
      handleTouchEnd() {
        this.isDragging = false;

        // Animación para abrir o cerrar el drawer según la posición
        const screenHeight = window.innerHeight-60;
        let drawerHeightPx = (this.drawerHeight * window.innerHeight) / 100

        if (drawerHeightPx > screenHeight / 1.08) {
          this.drawerHeight = (screenHeight / window.innerHeight) * 100;
        } else if (drawerHeightPx > screenHeight / 3 ) {
          this.drawerHeight = 90;
        }
        else{
          this.drawerHeight = 0;
        }
      },
      trackMixPanel(mensaje){
        mixpanel.track(mensaje, {
          pantalla: 'Drawer Login',
        });
      },
      register_auto_user(email){
        this.userRegister.email = email
        this.autoLogin = true
        this.register_user()
      },
      register_user(){
        if(this.user_not_register === false){
          if(!this.email_regex.test(this.userRegister.email)){
            this.tried_register = true
          }else{
            this.tried_register = false
            // TODO: LLAMADA A UN ENDPOINT NUEVO QUE COMPRUEBA SI ESTE CORREO ESTA REGISTRADO O NO
            var spinner = document.getElementById("spinner")
            spinner.classList.remove("d-none")

            const apiUrl = process.env.VUE_APP_API_URL+'/api/users/login-mail';
            const body = {
              email: this.userRegister.email
            }
            axios.post(apiUrl, body)
            .then(response => {
              this.$store.dispatch('setToken', response.data);
              spinner.classList.add("d-none")
              this.closeDrawer()
              // Solo si es la primera vez que identificas al usuario (por ejemplo, tras registro o login)
              mixpanel.alias(this.userRegister.email);
              mixpanel.identify(this.userRegister.email); // Agrupa eventos bajo este ID
              mixpanel.people.set({
                $email: this.userRegister.email
              });

              // Evento para monitorizar cuantos terminan de loguearse/registrase
              this.trackMixPanel("app_login_complete")

              if(!this.autoLogin){
                this.$emit("login-completed");
              }
              this.$emit('confirm-mail');
              
            })
            .catch(error => {
              console.error(error);
              this.trackMixPanel("app_login_error")
              this.user_not_register = true
              spinner.classList.add("d-none")
            });
          }
        }else{
          this.Register()
        }
      },
      async Register(){
        if(this.userRegister.name.length>0 && this.phone_regex.test(this.userRegister.mobile_phone) && this.email_regex.test(this.userRegister.email) && this.terms_conditions){
          var spinner = document.getElementById("spinner")
          spinner.classList.remove("d-none")

          this.userRegister.mobile_phone = this.userRegister.mobile_phone.replace(' ', '');

          const apiUrl = process.env.VUE_APP_API_URL+'/api/users';

          axios.post(apiUrl, this.userRegister)
          .then(response => {
            this.$store.dispatch('setToken', response.data);
            spinner.classList.add("d-none")
            /*this.registered = true
            setTimeout(() => {
              
            }, 2000);*/
            this.closeDrawer()
            mixpanel.alias(this.userRegister.email);
            mixpanel.identify(this.userRegister.email); // Agrupa eventos bajo este ID
            mixpanel.people.set({
              $email: this.userRegister.email
            });

            // Evento para monitorizar cuantos terminan de loguearse/registrase
            this.trackMixPanel("app_login_complete")

            this.$emit("login-completed");
            this.$emit('confirm-personal-data');
          })
          .catch(error => {
            console.error(error);
            this.error = true
            spinner.classList.add("d-none")
          });
        }else{
          this.tried_register = true
        }
      },
    },
  };
  </script>
<style scoped>
    .form-check-input:checked {
        background-color: #15E0DD;
        border-color: #15E0DD;
    }
</style>
